/**
 * <PaymentTd
 *		data={entire Row data including student info}
 *	/>
 *
 * @parent Table in Student
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
//

class PaymentTd extends React.Component {
  constructor(props) {
		super(props);
	}

	static propTypes = {
		classInfo: PropTypes.object,
	}

	render() {
		if (!this.props.classInfo) {
			return <div></div>
		}

		let {paidTotalFee} = this.props.classInfo;

		return (
			<div className='td-inner-content'>
        <span className={classnames({ 'alert-text': paidTotalFee === 0 })}>{'$' + paidTotalFee}</span>
			</div>
		);

  }
}

export default PaymentTd;



// WEBPACK FOOTER //
// ./src/containers/pages/Student/StudentTable/PaymentTd.js